import React, {useEffect} from 'react';
import LeaderBoardRow from './LeaderBoardRow';

export default function LeaderBoard(props) {
  let scores = [];
  let data = props.scoresData;
  if(data!==undefined){ 
    console.log("Leaderboard data:", data);   
    data.map((x, i) => {
      scores.push(<LeaderBoardRow 
        key={i}
        Name={x.player_name} 
        Score={x.player_score}
      ></LeaderBoardRow>);
    });
  }
 
  useEffect(() => {
  }, [props.scoresData]);
  
  return (
    <div>
      {props.title}
      <hr /> <div className="table">{scores}</div>
    </div>
  );
}
